<template>
  <div
    :class="[
      lightTheme ? 'scrollable__light' : 'scrollable__dark',
      horizontal ? 'scrollable--x' : '',
      vertical ? 'scrollable--y' : '',
    ]"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    vertical: {
      type: Boolean,
      default: true,
    },
    horizontal: {
      type: Boolean,
      default: true,
    },
    lightTheme: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/variables.scss";

.scrollable__dark {
  -webkit-overflow-scrolling: touch !important;

  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  &::-webkit-scrollbar-thumb,
  &::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: transparentize($color-on-background-area1, 0.45);
  }
  &:hover::-webkit-scrollbar-thumb {
    background: transparentize($color-on-background-area1, 0.35);

    &:hover {
      background: transparentize($color-on-background-area1, 0.35);
    }
  }
  &:hover::-webkit-scrollbar-track {
    background: transparentize($color-on-background-area1, 0.55);
  }
}
.scrollable__light {
  -webkit-overflow-scrolling: touch !important;

  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  &::-webkit-scrollbar-thumb,
  &::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: transparentize($color-background-area1, 0.45);
  }
  &:hover::-webkit-scrollbar-thumb {
    background: transparentize($color-background-area1, 0.35);

    &:hover {
      background: transparentize($color-background-area1, 0.35);
    }
  }
  &:hover::-webkit-scrollbar-track {
    background: transparentize($color-background-area1, 0.55);
  }
}
.scrollable--x {
  overflow-x: auto;
  overflow-y: hidden !important;

  &.only-x {
    overflow-x: auto !important;
    overflow-y: hidden !important;
  }
}
.scrollable--y {
  overflow-x: hidden !important;
  overflow-y: auto;

  &.only-y {
    overflow-x: hidden !important;
    overflow-y: auto !important;
  }
}
</style>
